<ng-container [formGroup]="form">
  <div class="flex flexJustify--between flexAlign--center ">
    <mat-form-field class="col__ ">
      <mat-label>Shift Timezone</mat-label>
      <mat-select data-test-id="timezone" formControlName="timezone">
        <mat-option *ngFor="let tz of timezones" [value]="tz">{{tz}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="fieldset__group flex">
    <mat-form-field class="col__ compact">
      <mat-select placeholder="Days of Week"
                  formControlName="shiftDays"
                  multiple>
        <mat-option *ngFor="let day of dayList"
                    [value]="day.value">{{day.label}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</ng-container>

<div class="fieldset__group fieldset__group--noBorder flex">
  <ng-container *ngFor="let dayItem of formModel">

    <div class="shiftSelect shiftSelect--light flex flexAlign--center col__ shiftSelect--{{dayItem.dayOfWeek}}"
         *ngIf="dayItem.selected">
      <span class="shiftSelect__label">{{dayItem.dayOfWeek | propercase}}</span>
      <div class="shiftSelect__controls-wrap">

        <div class="shiftSelect__controls shiftSelect__controls--{{dayItem.dayOfWeek}}--{{j}}"
             *ngFor="let shiftTime of dayItem.times; let j = index;">

          <div class="shiftSelect__times flex flexAlign--center">

              <mat-form-field class="shiftSelect__start compact mt-0050 mb-0050">
                <mat-label>Start Time</mat-label>
                <input type="time"
                       matInput

                       [matAutocomplete]="startTimeAutocomplete"
                       (change)="startTimeChanged($event.target.value, shiftTime)"
                       [min]="'00:00'"
                       [value]="shiftTime.startTime">
                <mat-autocomplete #startTimeAutocomplete="matAutocomplete"
                                  (optionSelected)="startTimeChanged($event.option.value, shiftTime)"
                                  (opened)="autoCompleteOpened('start', shiftTime.startTime)"
                                  [panelWidth]="120">
                  <ng-container *ngFor="let startTime of timeList">
                    <mat-option [value]="startTime.value">
                       {{startTime.text}}
                    </mat-option>
                  </ng-container>
                </mat-autocomplete>
              </mat-form-field>

            <span class="shiftSelect__to">
              <span class="d-inline d-none--md">&ndash;</span>
              <span class="d-none d-inline--md">to</span>
            </span>

              <mat-form-field class="shiftSelect__end compact mt-0050 mb-0050">
                <mat-label>End Time</mat-label>
                <input type="time"
                       #endTimeInput
                       [attr.data-shift-input-day-time]="dayItem.dayOfWeek + '-' + shiftTime.endTime"
                       matInput
                       [matAutocomplete]="endTimeAutocomplete"
                       #trigger="matAutocompleteTrigger"
                       (change)="endTimeChanged($event.target.value, shiftTime, trigger)"
                       [min]="'00:00'"
                       [value]="shiftTime.endTime">
                <mat-autocomplete #endTimeAutocomplete="matAutocomplete"
                                  (opened)="autoCompleteOpened('end', shiftTime.endTime)"
                                  (optionSelected)="endTimeChanged($event.option.value, shiftTime, dayItem.dayOfWeek, trigger)"
                                  [panelWidth]="120">
                  <ng-container *ngFor="let endTime of timeList">
                    <mat-option *ngIf="isEndAfterStart(shiftTime.startTime, endTime.value)"
                                [value]="endTime.value">
                       {{endTime.text}}
                    </mat-option>
                  </ng-container>
                  <mat-option value="next_day">
                    <span class="nowrap">Next Day&hellip;</span></mat-option>
                </mat-autocomplete>
              </mat-form-field>
            <button class="shiftSelect__add-time ml-0050 ml-0100--md"
                    type="button"
                    [ngClass]="{'disabled': addShiftDisabled(shiftTime.endTime)}"
                    [disabled]="addShiftDisabled(shiftTime.endTime)"
                    (click)="addShiftClicked(dayItem)"></button>

            <button class="shiftSelect__remove-time ml-0025 ml-0050--md"
                    type="button"
                    [disabled]="!hasStartOrEnd(shiftTime)"
                    [ngClass]="{'disabled': !hasStartOrEnd(shiftTime) }"
                    (click)="removeShiftClicked(dayItem, shiftTime)"></button>
          </div>
          <div>
            <button class="link"
                    type="button"
                    *ngIf="firstVisibleDay === dayItem"
                    [disabled]="!shiftTime.startTime || !shiftTime.endTime"
                    [ngClass]="{'disabled': !hasStartOrEnd(shiftTime) }"
                    (click)="onApplyShiftToAllClicked(shiftTime)">Add shift to all days</button>
          </div>

        </div>
        <div class="shiftSelect__overlap-warning caps"
             *ngIf="doShiftsOverlap(dayItem.times)">
          <strong class="color--red--003"
                  role="alert"><i class="fas fa-exclamation-triangle"></i> Shifts Overlap</strong>
        </div>
      </div>
    </div>
  </ng-container>
</div>
